import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import React from 'react';
import { isNumber } from '@finect/front-utils/isNumber';
import { AppLink } from '@finect/tabular-core/AppLink';
import { UnorderedList } from '@finect/tabular-core/UnorderedList';
import { isArray } from '@finect/front-utils/isArray';
import { Boolean } from '../Boolean';
import { AssetsLabel, PercentLabel } from '../../../Labels';
import { ListContainer, Block } from './partials';
export var ProductMetadata = function ProductMetadata(_ref) {
  var value = _ref.value,
    definition = _ref.definition;
  var _ref2 = value || {},
    link = _ref2.link,
    parsedValue = _ref2.parsedValue;
  var getContent = function getContent() {
    if ((!value || !parsedValue) && !(isNumber(value) || isNumber(parsedValue))) {
      return '-';
    }
    if (typeof parsedValue === 'boolean') {
      return React.createElement(Boolean, {
        value: parsedValue
      });
    }
    if (isArray(parsedValue)) {
      return React.createElement(ListContainer, null, parsedValue.map(function (item, key) {
        return React.createElement(UnorderedList, {
          key: key
        }, item);
      }));
    }
    if (definition && ['currency'].includes(definition.unit)) {
      return React.createElement(AssetsLabel, {
        value: parsedValue,
        decimals: 0
      });
    }
    if (definition && ['percent'].includes(definition.unit)) {
      return React.createElement(PercentLabel, {
        value: parsedValue,
        decimals: 2
      });
    }
    return value.data;
  };
  if (link) {
    return React.createElement(AppLink, {
      href: link.data,
      title: value.data
    }, value.data);
  }
  return React.createElement(Block, null, getContent());
};